import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';

export const useFlagReview = (reviewId: number): UseMutationResult =>
    useBffPostMutation(`/turn-to/reviews/${reviewId}/flag`, [], [BffQueryKey.TURN_TO_DATA]);
